import { type CountdownData } from 'src/types/classSession';

/**
 * Calculates the countdown from now until a target date.
 * Returns remaining days, hours, minutes and a flag indicating if we're within the join window.
 */
export const calculateCountdown = (dateStart: string | null): CountdownData => {
  if (!dateStart) {
    return { days: 0, hours: 0, minutes: 0, isLessThanThirtyMinutes: false };
  }

  const now = new Date();
  const start = new Date(dateStart);
  const diffMs = start.getTime() - now.getTime();
  const diffMinutes = Math.floor(diffMs / (1000 * 60));

  const isLessThanThirtyMinutes = diffMinutes < 30;

  if (diffMs <= 0) {
    return { days: 0, hours: 0, minutes: 0, isLessThanThirtyMinutes: true };
  }

  const minutesInDay = 60 * 24;
  const days = Math.floor(diffMinutes / minutesInDay);
  const remainingMinutes = diffMinutes % minutesInDay;
  const hours = Math.floor(remainingMinutes / 60);
  const minutes = remainingMinutes % 60;

  return { days, hours, minutes, isLessThanThirtyMinutes };
};
